import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import IeWarning from '../components/IeWarning';

import './index.css';

import { userActions, alertActions } from '../actions';

class TemplateWrapper extends Component {
  constructor(props) {
    super(props);
    this.handleWindowClose = this.handleWindowClose.bind(this);
  }

  handleWindowClose(event) {
    event.preventdefault();
    this.props.dispatch(userActions.logout());
  }
  componentDidMount() {
    require('boosted');
    window.addEventListener('onbeforeunload', this.handleWindowClose);
  }

  componentWillUnmount() {}
  render() {
    let isIE = undefined;
    if (typeof document !== 'undefined') {
      // Internet Explorer 6-11
      isIE = /*@cc_on!@*/ false || !!document.documentMode;
    }
    const { alert } = this.props;
    return (
      <div>
        <Helmet
          title="natural language"
          meta={[
            { name: 'description', content: 'disserto portal' },
            { name: 'keywords', content: 'disserto, support' },
          ]}
        />

        <Header />

        <div className="row">
          <div className="col-2 flex-column">
            <Menu />
          </div>

          <main className="col-9 flex-column" role="main">
            <IeWarning />
            <div className="card-body">
              {alert.message && (
                <div
                  className={
                    `alert ${alert.type}` + ' container col-6 flex-column'
                  }
                >
                  {alert.message}
                </div>
              )}
              {this.props.children()}
            </div>
          </main>
        </div>

        <Footer />
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
  dispatch: PropTypes.func,
  alert: PropTypes.object,
};

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

export default connect(mapStateToProps)(TemplateWrapper);



// WEBPACK FOOTER //
// ./src/layouts/index.js